<template>
  <div>
    <b-overlay :show="loadSurveyReport" spinner-variant="primary" spinner-type="grow" spinner-small rounded="md">

      <!-- REPORT TYPE MODAL -->
     
      <div class="d-flex justify-content-between">
        <div class="printReport mb-2 text-right">
          <b-button variant="danger" :disabled="faculties.length === 0" size="sm" @click="generateReport()">
            Download Survey Report
          </b-button>
        </div>

        <div class="w-50 d-flex flex-column">
          <b-form-select :options="groupsWithSubgroupsOptions" v-model="selectedGroupSubgroup"
            @change="getCourseReportBasedOnSubgroup"></b-form-select>
        </div>
      </div>

       <p class="p-4 text-info" style="font-size: 14px; font-weight: 600">
        <strong>Equation Used for the report:</strong>
        <br />
        <strong>Avg. score of a question = sum(score*no. of students selected)/ total
          no. of students <br> Teaching effectiveness (%) = sum(avg. score of a
          question) / sum(maximum score of each question) *100</strong>
      </p>

      <div class="loading" v-if="fetchData">
        <load-data></load-data>
      </div>
      

      <!-- REPORT DISPLAY -->
      <div v-else class="p-4" id="surveyCourseReport">

        <h6 class="text-danger" style="font-size:18px;font-weight:600" v-if="faculties.length === 0">
          No Data Found!
        </h6>

        <div v-for="(course, cIdx) in faculties" :key="cIdx" style="margin-bottom:40px">
          <div v-for="(faculty, fIdx) in course.faculties" :key="fIdx" class="border border-info p-2 rounded">

            <h5 class="text-center text-uppercase" style="font-size:22px;font-weight:700">
              {{ selectedInstitute.name }}
            </h5>

            <h5 style="font-size:18px;font-weight:600">
              Survey Report for:
              {{ course.name }} - {{ faculty.first_name }} {{ faculty.last_name }}
              ({{ course.group }}-{{ course.subgroup }})
            </h5>

            <table class="table table-bordered table-striped">
              <thead class="thead-dark">
                <tr>
                  <th>Sr No.</th>
                  <th>Question</th>
                  <th>Choices</th>
                  <th>Scores</th>
                  <th>No. of Selections</th>
                  <th>Avg. Score</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(q, qIdx) in quesChoices" :key="qIdx">
                  <td>{{ qIdx + 1 }}</td>
                  <td>{{ q.name }}</td>

                  <td>
                    <p v-for="c in q.choices" :key="c.id">{{ c.name }}</p>
                  </td>

                  <td>
                    <p v-for="c in q.choices" :key="c.id">{{ c.score }}</p>
                  </td>

                  <td class="text-center">
                    <p v-for="c in q.choices" :key="c.id">
                      {{ answersNumber[course.id][faculty.id][q.id].choices[c.id].length }}
                    </p>
                  </td>

                  <td class="text-center">
                    {{ answersNumber[course.id][faculty.id][q.id].avarage }}
                  </td>
                </tr>

                <tr>
                  <td colspan="5" class="text-center">Total No. of Students Attended</td>
                  <td class="text-center">{{ faculty.studentCount }}</td>
                </tr>

                <tr>
                  <td colspan="5" class="text-center">Teacher Score</td>
                  <td class="text-center">{{ faculty.teacherScore }}</td>
                </tr>

                <tr>
                  <td colspan="5" class="text-center">Teacher Score Percentage</td>
                  <td class="text-center">{{ faculty.teacherScorePersentage }}%</td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>

      </div>

    </b-overlay>
  </div>
</template>

<script>
export default {
  props: ["survey_id", "groupsWithSubgroupsOptions", "selectedSurveyType", "selectedGroupSubgroup"],

  data() {
    return {
      fetchData: false,
      loadSurveyReport: false,
      faculties: [],
      quesChoices: [],
      answersNumber: {},
      selectedInstitute: {},
      selectedGroupSubgroupCode: null,
      singleorindividual:"individual"
    };
  },

  async mounted() {
    this.selectedInstitute = this.$store.getters.getCurrentInstitution;
  },


  watch: {
    selectedGroupSubgroup(newVal) {
      if (!newVal) return;
      const found = this.groupsWithSubgroupsOptions.find(x => x.value == newVal);
      this.selectedGroupSubgroupCode = found ? found.code : null;
    },
    groupsWithSubgroupsOptions:
    {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 1 && this.selectedGroupSubgroup) {
          this.getCourseReportBasedOnSubgroup();
        }
      },
    },
  },
  methods: {
   

    getCourseReportBasedOnSubgroup() {
      this.fetchData = true;

      const url = this.$store.getters.getAPIKey.mainAPI +
        `/studfbsurveys/${this.survey_id}/report`;

      this.$axios.post(url, { usersubgroup: this.selectedGroupSubgroup })
        .then(res => {
          this.faculties = res.data.courses_faculties || [];
          this.quesChoices = res.data.questions_choices || [];
          this.answersNumber = res.data.students_in_question_choices || {};
          this.fetchData = false;
        })
        .catch(() => this.fetchData = false);
    },

    generateReport() {
         
            this.loadSurveyReport = true;
            const url =
                this.$store.getters.getAPIKey.mainAPI +
                `/studfbsurveys/${this.survey_id}/report/pdfexport?custom_report=${this.reportType
                }&individualfiles=${this.singleorindividual == "individual" ? 1 : 0}`;
            this.$axios
                .post(
                    url,
                    {
                        usersubgroup:
                            this.selectedGroupSubgroup != null
                                ? this.selectedGroupSubgroup
                                : null,
                    },
                    { responseType: "blob" }
                )
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    var tempFileName =
                        this.singleorindividual == "individual"
                            ? "Instructor Feedback Survey(Single PDF File).zip"
                            : "Instructor Feedback Survey(Single PDF File).pdf";
                    link.setAttribute("download", tempFileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.loadSurveyReport = false;
                })
                .catch(() => {
                    this.loadSurveyReport = false;
                });
        },

  }
};
</script>
